import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";

interface IReferrerOtherReferrer {

}

export const ReferralOtherReferrer: React.FunctionComponent<IReferrerOtherReferrer> = ({ }) => {

    return (
        <div className="row">
            <h5 className="col-12">Annan vårdgivare</h5>
            <div className="col-6">
                <TextInput name="referrerAddressName" label="Mottagning" inlineLabel maxLength={255} required />
            </div>
            <div className="col-6">
                <TextInput name="referrerStreetName" label="Adress" inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="referrerPostalCode" label="Postnummer" inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="referrerPostalCity" label="Ort" inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="referrerTelephoneNumber" label="Telefonnummer" inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="referrerAltTelephoneNumber" label="Alt. telefonnummer" inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="referrerEmailAddress" label="E-post" inlineLabel />
            </div>
        </div>
    )
}